import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import Clarity from '@microsoft/clarity'
import App from './App.tsx'
import './index.css'

const root = createRoot(document.getElementById('root')!)

root.render(
    <StrictMode>
        <App />
    </StrictMode>,
)

Clarity.init('tlfa2hjjge')

// 预渲染支持：在应用渲染完成后触发事件
// 这个事件会被 vite-plugin-prerender 捕获，表示页面已经准备好了
if (typeof window !== 'undefined') {
    // 等待 DOM 更新和组件挂载完成
    setTimeout(() => {
        // 触发预渲染完成事件
        const event = new Event('render-event')
        document.dispatchEvent(event)

        // 可选：在控制台输出日志用于调试
        console.log('Prerender event dispatched')
    }, 100)
}
